/**
 *
 * @param el
 * @param evt
 * @param fn
 */
function addEvent( el, evt, fn ) {
    if ( el.addEventListener ) {
      el.addEventListener( evt, fn );
    } else if ( el.attachEvent ) {
      el.attachEvent( 'on' + evt, function( evt ) {
        fn.call( el, evt );
      } );
    } else if ( typeof el['on' + evt] === 'undefined' || el['on' + evt] === null ) {
      el['on' + evt] = function( evt ) {
        fn.call( el, evt );
      };
    }
  }
  
  /**
   *
   */
  function getBrandOrSolution() {
    var url = location.href;
    if ( ( url.indexOf( '/brands/' ) > -1 ) || ( url.indexOf( '/solutions/' ) > -1 ) ) {
      var urlCheck = /(\/brands\/|\/solutions\/)(.*\/)/ig;
      var match = urlCheck.exec( url );
      if ( match !== null ) {
        return match[2].replace( /\//g, '' );
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  
  addEvent( window, 'message', function( message ) {
    if ( message.data.sendToGTM ) {
      var dataLayer = window.dataLayer || ( window.dataLayer = [] );
      if ( !message.data.brandOrSolution ) {
        message.data.brandOrSolution = getBrandOrSolution();
      }
      //Title Case the solution and change spaces to underscores.
      message.data.brandOrSolution = formatBrandOrSolution( message.data.brandOrSolution );
      var data = Object.assign( {}, message.data );
      delete data.sendToGTM;
      dataLayer.push( data );
    }
  } );
  
  /**
   *
   * @param brandOrSolution
   */
  function formatBrandOrSolution( brandOrSolution ) {
    return brandOrSolution.replace( /%20/g, ' ' )
      .replace( /-/g, ' ' )
      .replace( /\w\S*/g, function( txt ) {
        return txt.charAt( 0 ).toUpperCase() + txt.substr( 1 ).toLowerCase();
      } )
      .replace( / /g, '_' );
  }
  
  /**
   *
   */
  function updateIframeSrc() {
    var iFrames = document.getElementsByTagName( 'iframe' );
    for ( var i = 0; i < iFrames.length; i++ ) {
      if ( iFrames[i].src.match( /go.pardot.com/ ) ) {
        if ( iFrames[i].src.indexOf( '?' ) > -1 ) {
          iFrames[i].src = iFrames[i].src + '&parent_url=' + location.href;
        } else {
          iFrames[i].src = iFrames[i].src + '?parent_url=' + location.href;
        }
      }
    }
  }
  
  updateIframeSrc();
  